import React, { useState } from "react";
import { DatePickerWithHighlights } from "./DatePickerWithHighlights";
import { Col, Row } from "../../components/Layout";

export const TruckFormElements = (props) => {
  const {
    avisDateError,
    truckplateError,
    trailorplateError,
    driverNameError,
    estimatedArrivalDateError,
    truckplateList,
    highlightedDates,
  } = props;

  const [truckPlate, setTruckPlate] = useState("");
  const [trailerPlate, setTrailerPlate] = useState("");
  const [driverName, setDriverName] = useState("");

  // Convert and store string highlightedDates into dateArray if present otherwise empty
  const dateArray = highlightedDates
    ? highlightedDates.split(",").map((date) => new Date(date.trim()))
    : [];

  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  // Filter to check date should be greater than or equal to today for highlight
  let filteredDates = dateArray.filter((date) => {
    date.setHours(0, 0, 0, 0); // Setting hours to 0 for date comparison
    return date >= currentDate;
  });

  const handleTruckPlateChange = (event) => {
    const enteredText = event.target.value;
    setTruckPlate(enteredText);

    if (truckplateList) {
      const matchingOption = truckplateList.find(
        (item) => item.truckPlate.toLowerCase() === enteredText.toLowerCase()
      );

      if (matchingOption) {
        setTrailerPlate(matchingOption.trailerPlate);
        setDriverName(matchingOption.driverName);
      } else {
        setTrailerPlate("");
        setDriverName("");
      }
    }
  };

  const [avisdateState, setAvisdateState] = useState(null);
  const [estimatedArrivalDateState, setEstimatedArrivalDateState] =
    useState(null);

  const maxDate = new Date(new Date().setMonth(new Date().getMonth() + 3));

  return (
    <Col className="text-base space-y-4">
      <Row className="items-center">
        <label className="text-xs w-40 flex-shrink-0">Planned Loading Date :</label>
        <div className="flex-1">
          <DatePickerWithHighlights
            name="avisdate"
            value={avisdateState}
            onChange={(date) => {
              setAvisdateState(date[0]);
            }}
            enableTime="true"
            max={maxDate}
            highlightedDates={filteredDates}
          />
          {avisDateError && (
            <p className="text-xs text-red-500 mt-1">
              Date is invalid
            </p>
          )}
        </div>
      </Row>

      <Row className="items-center">
        <label className="text-xs w-40 flex-shrink-0">Estimated Arrival Date :</label>
        <div className="flex-1">
          <DatePickerWithHighlights
            name="estimatedArrivalDate"
            enableTime="false"
            value={estimatedArrivalDateState}
            onChange={(date) => {
              setEstimatedArrivalDateState(date[0]);
            }}
            min={new Date()}
            max={maxDate}
          />
          {estimatedArrivalDateError && (
            <p className="text-xs text-red-500 mt-1">
              Date is invalid
            </p>
          )}
        </div>
      </Row>

      <Row className="items-center">
        <label className="text-xs w-40 flex-shrink-0">Truck Plate :</label>
        <div className="flex-1">
          <input
            className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
            name="truckplate"
            defaultValue={""}
            value={truckPlate}
            onChange={handleTruckPlateChange}
            type="text"
          />
          {truckplateError && (
            <p className="text-xs text-red-500 mt-1">
              Truck plate is invalid
            </p>
          )}
        </div>
      </Row>

      <Row className="items-center">
        <label className="text-xs w-40 flex-shrink-0">Trailer Plate :</label>
        <div className="flex-1">
          <input
            className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
            name="trailorplate"
            defaultValue={""}
            value={trailerPlate}
            type="text"
            onChange={(event) => setTrailerPlate(event.target.value)}
          />
          {trailorplateError && (
            <p className="text-xs text-red-500 mt-1">
              Trailer plate is invalid
            </p>
          )}
        </div>
      </Row>

      <Row className="items-center">
        <label className="text-xs w-40 flex-shrink-0">Driver Name :</label>
        <div className="flex-1">
          <input
            className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
            name="driverName"
            value={driverName}
            defaultValue={""}
            type="text"
            onChange={(event) => setDriverName(event.target.value)}
          />
          {driverNameError && (
            <p className="text-xs text-red-500 mt-1">
              Driver name is invalid
            </p>
          )}
        </div>
      </Row>
    </Col>
  );
};
